import { Link } from "react-router-dom";
import { ClipboardCheck, Ear, LayoutGrid, Shield, UserMinus, Users } from "lucide-react";
import { ROUTES } from "@/config/constants";

const ITENS = [
  { to: ROUTES.GENTE_GESTAO_VISAO, label: "Visão geral", caption: "Painel", icon: LayoutGrid },
  { to: ROUTES.GENTE_GESTAO_COLABORADORES, label: "Colaboradores", caption: "Cadastro", icon: Users },
  { to: ROUTES.GENTE_GESTAO_NPS, label: "Pesquisas eNPS", caption: "Clima", icon: ClipboardCheck },
  { to: ROUTES.GENTE_GESTAO_LIDERANCA, label: "Avaliação de Liderança", caption: "180 graus", icon: Shield },
  { to: ROUTES.GENTE_GESTAO_ESCUTA, label: "Escuta Ativa", caption: "Canal seguro", icon: Ear },
  { to: ROUTES.GENTE_GESTAO_DESLIGAMENTO, label: "Entrevista de desligamento", caption: "Saída", icon: UserMinus },
];

export function GenteGestaoMenuPage() {
  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-xl font-bold text-slate-800">Gente & Gestão</h1>
      <nav className="grid grid-cols-2 gap-3 sm:grid-cols-3">
        {ITENS.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className="flex flex-col items-center gap-3 rounded-2xl border border-slate-200 bg-white px-3 py-5 text-center shadow-card transition-colors hover:border-brand-200 hover:bg-brand-50/40"
          >
            <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-brand-100 text-brand-700">
              <item.icon className="h-8 w-8" strokeWidth={1.75} />
            </span>
            <span>
              <span className="block text-sm font-semibold leading-tight text-slate-800">{item.label}</span>
              <span className="mt-1 block text-xs text-slate-400">{item.caption}</span>
            </span>
          </Link>
        ))}
      </nav>
    </div>
  );
}
